import { forwardRef } from "react";
import { Icon, type IconProps } from "../Icon";

export const ChevronsLeft = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => {
    return (
      <Icon ref={ref} {...props}>
        <path d="m11 17-5-5 5-5M18 17l-5-5 5-5" />
      </Icon>
    );
  },
);

ChevronsLeft.displayName = "ChevronsLeft";
